import { SxProps, Theme } from '@mui/material';

export const getTextAreaContainerSx = (hasError: boolean = false): SxProps<Theme> => ({
  paddingY: '12px',
  paddingX: '16px',
  borderRadius: '8px',
  border: hasError ? '1px solid var(--color-error-red)' : '1px solid var(--color-border)',
  '&:hover:not(:has(textarea:focus))': {
    borderColor: hasError ? 'var(--color-error-red)' : 'var(--color-text-placeholder)'
  },
  '&:has(textarea:hover):not(:has(textarea:focus))': {
    borderColor: hasError ? 'var(--color-error-red)' : 'var(--color-text-placeholder)'
  },
  '&:has(textarea:focus)': {
    borderColor: hasError ? 'var(--color-error-red)' : 'var(--color-primary)'
  }
});

export const textAreaContainerSx: SxProps<Theme> = getTextAreaContainerSx(false);

export const getTextAreaSx = (): SxProps<Theme> => ({
  width: '100%',
  border: 'none',
  outline: 'none',
  fontFamily: 'Inter',
  fontSize: { xs: '14px', sm: '16px' },
  lineHeight: { xs: '20px', sm: '24px' },
  color: 'var(--color-text-input)',
  resize: 'vertical',
  '&::placeholder': {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    color: 'var(--color-text-placeholder)',
    opacity: 1
  },
  '&:focus': {
    border: 'none',
    outline: 'none'
  },
  '&:hover': {
    border: 'none',
    outline: 'none'
  }
});

export const textAreaSx: SxProps<Theme> = getTextAreaSx();

export const characterCountSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 'var(--font-size-16)',
  lineHeight: 'var(--line-height-24)',
  textAlign: 'right',
  color: 'var(--color-text-placeholder)'
};
